import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpInputDescription } from "../../gvc/testNewForm/CpInputDescription";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";
import { KindSelectState } from "../../../components/antd/kindselect/KindSelect";

interface Props {
  lockedGvc?: KindSelectState;
}
export const General: React.FC<Props> = ({ lockedGvc }) => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            Volume Set
            <CpErrorWarningArrayIcon names={[`name`, "description", "gvc"]} />
          </CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`name`}>Name</CpLabel>
                <CpTooltip tooltipProps={{ title: "Cannot be changed after creation (ok, my-item, item1)" }} />
              </CpLabelTooltip>
              <CpInput name={`name`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`name`} />
            </CpFormItem>
            <CpInputDescription namePath="name" descriptionPath="description" />
            {lockedGvc ? (
              <CpFormItem>
                <CpLabelTooltip>
                  <CpLabel name={`skip`}>GVC</CpLabel>
                  <CpTooltip
                    tooltipProps={{
                      title: `Volume Sets are GVC scoped items, this will be the parent GVC for this volume set.`,
                    }}
                  />
                </CpLabelTooltip>
                <div>{lockedGvc.value}</div>
              </CpFormItem>
            ) : (
              <CpFormItem>
                <CpLabelTooltip>
                  <CpLabel name={`gvc`}>GVC</CpLabel>
                  <CpTooltip
                    tooltipProps={{
                      title: `Volume Sets are GVC scoped items, this will be the parent GVC for this volume set.`,
                    }}
                  />
                </CpLabelTooltip>
                <CpKindSelect kind="gvc" name="gvc" optionValue="name" style={{ maxWidth: 600 }} />
                <CpErrorWarning name={`gvc`} />
              </CpFormItem>
            )}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
